module.exports = __webpack_public_path__ + "static/media/Kiki_Main.c22c5541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kiki_Main.jpg
// module id = 176
// module chunks = 0